import { useNavigation } from '@/caregiverSpace/shared/lib';
import { ICaregiverConsultationDto } from '@/caregiverSpace/shared/model';
import { GoToPageButton } from '@/caregiverSpace/shared/ui';

type PatientNameViewProps = {
    consultation: Partial<ICaregiverConsultationDto>;
    className?: string;
};

export const PatientNameView = ({
    consultation,
    className,
}: PatientNameViewProps) => {
    const {
        goToPatientPage,
        goToPetPage,
        goToProfileConsultation,
        goToPetConsultation,
    } = useNavigation();

    if (consultation.Patient) {
        return (
            <GoToPageButton
                onClick={() =>
                    consultation.Uid
                        ? goToProfileConsultation(
                              consultation.Patient.PatientId,
                              consultation.Uid,
                          )
                        : goToPatientPage(consultation.Patient.PatientId)
                }
                className={className}
            >
                {consultation.Patient.PatientName}
            </GoToPageButton>
        );
    } else {
        return (
            <GoToPageButton
                onClick={() =>
                    consultation.Uid
                        ? goToPetConsultation(
                              consultation.Pet.PetId,
                              consultation.Uid,
                          )
                        : goToPetPage(consultation.Pet.PetId)
                }
                className={className}
            >
                {consultation.Pet.PetName}
            </GoToPageButton>
        );
    }
};
